import { SelectItem } from 'primeng/api';
import { ProductDevelopmentStatus } from '@app/models/item/enum/product-development-status';
import { ClientPOItemFilter } from './client-purchase-order';
import { ClientPOStatus } from './client-purchase-order-enums';

// Keep in sync with Order.API ClientPurchaseOrderHelpers.ValidateStatusChange.
export const CLIENT_PO_STATUS_TRANSITIONS: Record<number, number[]> = {
  [ClientPOStatus.Draft]: [ClientPOStatus.Submitted, ClientPOStatus.Cancelled, ClientPOStatus.Deleted],
  [ClientPOStatus.Submitted]: [ClientPOStatus.Approved, ClientPOStatus.Draft, ClientPOStatus.Cancelled],
  [ClientPOStatus.Approved]: [ClientPOStatus.InProduction, ClientPOStatus.Cancelled],
  [ClientPOStatus.InProduction]: [ClientPOStatus.PartiallyDispatched, ClientPOStatus.Dispatched],
  [ClientPOStatus.PartiallyDispatched]: [ClientPOStatus.Dispatched],
  [ClientPOStatus.Dispatched]: [],
  [ClientPOStatus.Cancelled]: [],
  [ClientPOStatus.Deleted]: [],
};

// Only 0% (exempt) and 15% (standard) are allowed until tax rates come from a real lookup.
export const CLIENT_PO_DEFAULT_TAX_RATE = 0.15;
export const CLIENT_PO_TAX_RATE_OPTIONS: SelectItem<number>[] = [
  { label: '0%', value: 0 },
  { label: '15%', value: CLIENT_PO_DEFAULT_TAX_RATE },
];

export const CLIENT_PO_ITEM_SEARCH_STATUSES = [ProductDevelopmentStatus.Approved, ProductDevelopmentStatus.ReadyForProduction];
export const CLIENT_PO_RECIPE_SEARCH_STATUSES = [ProductDevelopmentStatus.ReadyForProduction];

export const CLIENT_PO_ITEM_FILTERS: ClientPOItemFilter[] = [
  { key: 'inventoryType', labelKey: 'Client_PO_InventoryType', fallbackLabel: 'Inventory Type' },
];
